import React from 'react'
import { navigate as n, Link as GatsbyLink } from 'gatsby-link'
import { buildQueryUrl, isMaintMode } from '../../utils/helperFn'

export const navigate = (path: string): void => {
  isMaintMode() ? n(buildQueryUrl('', path, { bypass: 'true' })) : n(path)
}

interface WrappedLinkProps {
  to: string;
  children: JSX.Element | string | number | null;
  [key: string]: any;
}

const WrappedLink = ({ to, children, ...rest }: WrappedLinkProps): JSX.Element =>
  isMaintMode() ? (
    <GatsbyLink to={buildQueryUrl('', to, { bypass: 'true' })} {...rest}>
      {children}
    </GatsbyLink>
  ) : (
    <GatsbyLink to={to} {...rest}>
      {children}
    </GatsbyLink>
  )

export default WrappedLink
